const getLocaleDate = (ts, locale, options = {}) => {
  const d = new Date(ts);

  if (d instanceof Date && !isNaN(d)) {
    return d.toLocaleDateString(locale, options);
  }
  return '';
};

export {
  getLocaleDate
};
